import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExpertCalibrationService {

  constructor(private http:HttpClient) { }
  GetRecord():Observable<Array<ExpertCalibration_Interface>>{
    return this.http.get(environment.BaseUrl
      + "Daro/ExpertCalibration").pipe(
      map(data=>{
        return data as Array<ExpertCalibration_Interface>
      })
    )
  }

  GetActiveList(Expert1:boolean,Expert2:boolean,Expert3:boolean):Observable<Array<ExpertCalibration_Interface>>{
    return this.http.get(environment.BaseUrl
      + "Daro/ExpertCalibration/GetActiveList?Expert1="+Expert1
      +"&Expert2="+Expert2
      +"&Expert3="+Expert3).pipe(
      map(data=>{
        return data as Array<ExpertCalibration_Interface>
      })
    )
  }

  GetSingle(id:Number):Observable<ExpertCalibration_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/ExpertCalibration/GetSingle?id="+id).pipe(
      map(data=>{
        return data as ExpertCalibration_Interface
      })
    )
  }

  AddExpertCalibration(model: ExpertCalibration_Interface):Observable<ExpertCalibration_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      person_id:model.person_id,
      area_type:model.area_type,
      response:model.response,
      dsc:model.dsc,
      del:false,
      create_username:'',
    }



      return this.http.post(environment.BaseUrl + "Daro/ExpertCalibration/Add",body,{headers}).pipe(
        map(data=>{
          return data as ExpertCalibration_Interface
        })
      )

  }

  EditExpertCalibration(model: ExpertCalibration_Interface):Observable<ExpertCalibration_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      id:model.id,
      area_type:model.area_type,
      response:model.response,
      dsc:model.dsc,
      del:false,
      create_username:'',
    }

    console.log(body);



      return this.http.post(environment.BaseUrl + "Daro/ExpertCalibration/Edit",body,{headers}).pipe(
        map(data=>{
          return data as ExpertCalibration_Interface
        })
      )

  }

  DeleteExpertCalibration(id:number):Observable<ExpertCalibration_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/ExpertCalibration/Delete?id="+id).pipe(
        map(data=>{
          return data as ExpertCalibration_Interface
        })
      )

  }

  }
